import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import OrderManagement from './pages/OrderManagement';
import PointsManagement from './pages/PointsManagement';
import AnnouncementManagement from './pages/AnnouncementManagement';
import InvitationCodeManagement from './pages/InvitationCodeManagement';
import HistoryPage from './pages/History/HistoryPage';
import Login from './pages/Login';
import Register from './pages/Register';
import HomePage from './pages/HomePage';
import PrivateRoute from './components/PrivateRoute';
import MainLayout from './components/MainLayout';
import { OrderImportProvider } from './contexts/OrderImportContext';
import { OrderWorkspaceProvider } from './contexts/OrderWorkspaceContext';
import { AuthProvider } from './contexts/AuthContext';
import { checkVersionAndClearCache } from './utils/cacheBuster';
import './App.css';

function App() {
  // 在应用启动时检查版本
  useEffect(() => {
    checkVersionAndClearCache();
  }, []);

  return (
    <AuthProvider>
      <OrderImportProvider>
        <OrderWorkspaceProvider>
          <Layout style={{ minHeight: '100vh' }}>
            <Routes>
              {/* 公开路由 */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/" element={<Navigate to="/home" replace />} />

              {/* 受保护的路由 */}
              <Route
                path="/app"
                element={
                  <PrivateRoute>
                    <MainLayout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate to="/app/orders" replace />} />
                <Route path="/app/orders/*" element={<OrderManagement />} />
                <Route path="/app/points/*" element={<PointsManagement />} />
                <Route
                  path="/app/announcements/*"
                  element={
                    <PrivateRoute adminOnly>
                      <AnnouncementManagement />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/app/invitation-codes/*"
                  element={
                    <PrivateRoute adminOnly>
                      <InvitationCodeManagement />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/app/history"
                  element={
                    <PrivateRoute adminOnly>
                      <HistoryPage />
                    </PrivateRoute>
                  }
                />
              </Route>

              {/* 404处理 - 所有未匹配的路径重定向到首页 */}
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </Layout>
        </OrderWorkspaceProvider>
      </OrderImportProvider>
    </AuthProvider>
  );
}

export default App;
